import style from "./appModePage.module.scss";
import AccountHeader from "../../components/AppAccount/AccountHeader";
import {
  clearFavourites,
  DRUG_INDEX_FAVOURITES_STORAGE_KEY,
  getFavourites,
  saveFavourite,
  TOPIC_FAVOURITES_STORAGE_KEY,
} from "../../components/FavouriteButton/favouritesService";
import Favourite from "../../components/AppAccount/Favourite";
import { useState } from "react";
import Dialog from "./Dialog";
import TabGroup from "../../components/TabGroup/TabGroup";
import { useSearchParams } from "react-router-dom";

const TOPIC_FAVOURITES_TAB_ID = "topics";
const DRUG_INDEX_FAVOURITES_TAB_ID = "drug-index";
const TOPIC_FAVOURITES_LIST_LABEL = "topic favourites";
const DRUG_INDEX_FAVOURITES_LIST_LABEL = "drug index favourites";

const FavouriteList = ({ emptyFavouritesMessage, storageKey }) => {
  const [favourites, setFavourite] = useState(getFavourites(storageKey));
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const favouritesListLabel =
    storageKey === DRUG_INDEX_FAVOURITES_STORAGE_KEY
      ? DRUG_INDEX_FAVOURITES_LIST_LABEL
      : TOPIC_FAVOURITES_LIST_LABEL;

  const removeFavourite = (title, url, type, guideline) => {
    saveFavourite(title, url, type, guideline, undefined, storageKey);
    setFavourite(getFavourites(storageKey));
  };

  const clearAllFavourites = () => {
    clearFavourites(storageKey);
    setFavourite(getFavourites(storageKey));
    setConfirmDialogOpen(false);
  };

  return (
    <>
      {favourites.length > 0 && (
        <div className={style.clearAllActions}>
          <button className={style.clearAllButton} onClick={() => setConfirmDialogOpen(true)}>
            Clear all
          </button>
        </div>
      )}
      {favourites.length > 0 ? (
        favourites.map((favourite, index) => (
          <Favourite
            title={favourite.favouriteTitle}
            url={favourite.favouriteUrl}
            guideline={favourite.topicSection?.replace("/", "")}
            type={favourite.type}
            sectionId={favourite.sectionId}
            removeFavourite={removeFavourite}
            key={`favId-${storageKey}-${index}`}
          ></Favourite>
        ))
      ) : (
        <div className={style.emptyTabLine}>{emptyFavouritesMessage}</div>
      )}
      <Dialog
        bodyText={`Are you sure you want to clear all items from your ${favouritesListLabel} list? This action cannot be undone.`}
        confirmFunction={clearAllFavourites}
        heading="Confirmation"
        buttonText="Clear all"
        isOpen={confirmDialogOpen}
        setIsOpen={setConfirmDialogOpen}
      ></Dialog>
    </>
  );
};

const TopicFavouritesTab = () => (
  <FavouriteList
    emptyFavouritesMessage="You have no topic favourites."
    storageKey={TOPIC_FAVOURITES_STORAGE_KEY}
  />
);

const DrugIndexFavouritesTab = () => (
  <FavouriteList
    emptyFavouritesMessage="You have no drug index favourites."
    storageKey={DRUG_INDEX_FAVOURITES_STORAGE_KEY}
  />
);

const FavouritesPage = () => {
  const [searchParams] = useSearchParams();
  const defaultTabId =
    searchParams.get("tab") === DRUG_INDEX_FAVOURITES_TAB_ID
      ? DRUG_INDEX_FAVOURITES_TAB_ID
      : TOPIC_FAVOURITES_TAB_ID;

  const favouriteTabs = [
    {
      id: TOPIC_FAVOURITES_TAB_ID,
      label: "Topics",
      component: TopicFavouritesTab,
    },
    {
      id: DRUG_INDEX_FAVOURITES_TAB_ID,
      label: "Drug index",
      component: DrugIndexFavouritesTab,
    },
  ];

  return (
    <div className={style.favouriteAccountContainer}>
      <div className={style.mobileOnly}>
        <AccountHeader headername="My favourites" />
      </div>
      <TabGroup
        tabs={favouriteTabs}
        defaultId={defaultTabId}
        tabButtonClassName={style.favouritesTabButton}
        alignLeft={true}
        borderBottom={true}
      />
    </div>
  );
};

export default FavouritesPage;
